/**
 * lib/auth-client.ts
 * Better Auth クライアントSDK — framework-agnostic版
 * 'better-auth/react' は React internals に依存して crash するため使わない
 * https://better-auth.com/docs/concepts/client
 */
import { createAuthClient } from 'better-auth/client'
import { magicLinkClient } from 'better-auth/client/plugins'

export const authClient = createAuthClient({
  // Same-origin: /api/auth/* proxied to auth worker via CF Pages Functions
  // Eliminates cross-origin DNS/CORS issues
  baseURL: window.location.origin,
  plugins: [magicLinkClient()],
})
